import { provideToastr } from 'ngx-toastr';
import { EnvironmentProviders } from '@angular/core';

export const provideToast = (): EnvironmentProviders =>
  provideToastr({
    preventDuplicates: true,
    resetTimeoutOnDuplicate: true,
    tapToDismiss: false,
  });
